import Pill from './Pill';
import usePrecoEnrollmentStatus, {
  PRECO_ENROLLMENT_STATUS,
} from 'hooks/usePrecoEnrollmentStatus';

const PRECO_STATUS_PILL_TEXT = {
  [PRECO_ENROLLMENT_STATUS.ELIGIBLE]: 'PreCO Offer Available!',
  [PRECO_ENROLLMENT_STATUS.ACTIVE]: 'Active PreCO Offer',
  [PRECO_ENROLLMENT_STATUS.COMPLETED]: 'Completed PreCO Offer',
};

const PrecoOfferPill = ({ account }) => {
  const { enrollmentStatus, loading } = usePrecoEnrollmentStatus(account);

  if (loading) {
    return <Pill>Checking offers...</Pill>;
  }

  if (!enrollmentStatus) {
    return null;
  }

  return <Pill color="teal">{PRECO_STATUS_PILL_TEXT[enrollmentStatus]}</Pill>;
};

export default PrecoOfferPill;
